import { assign } from 'lodash';

// defalt animation settings
const DEFAULT_SETTINGS = {
	duration: 0.5,
	delay: 0,
	staggered: false,
};

// fade in and out animation config function
export const fadeInOut = _settings => {
	const settings = assign( {}, DEFAULT_SETTINGS, _settings );

	// variants
	const variants = {
		initial: { opacity: 0 },
		enter: {
			opacity: 1,
			transition: {
				duration: settings.duration,
				delay: settings.delay,
			},
		},
		exit: {
			opacity: 0,
			transition: {
				duration: settings.duration,
				delay: settings.delay,
			},
		}
	};

	return {
		variants,
		initial: 'initial',
		...(
            settings.staggered ? {} : {
				animate: 'enter',
				exit: 'exit',
            }
        )
	};
};

